export default __webpack_public_path__ + "static/media/1916.dd102dee.png";